import { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCoffee,
  faUtensils,
  faExclamationTriangle,
  faCircleInfo,
} from '@fortawesome/free-solid-svg-icons';
import { faAccessibleIcon } from '@fortawesome/free-brands-svg-icons';
import { dateFormat } from 'utils/shared/utils';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { useTranslation } from 'react-i18next';
import { b2b } from 'constants/generic';

interface RoomIconsProps {
  boardCode: string;
  limitDate: string;
  ada: boolean;
  hideRemarks?: boolean;
  hasRemarks?: boolean;
  onCancellationClick?: () => void;
  onRemarksClick?: () => void;
  shortMode?: boolean;
}

const RoomIcons: FC<RoomIconsProps> = ({
  boardCode,
  limitDate,
  ada,
  hasRemarks,
  hideRemarks,
  onCancellationClick,
  onRemarksClick,
  shortMode = false,
}) => {
  const { i18n, t } = useTranslation();

  const validBoardCode = boardCode && boardCode !== 'null' ? boardCode : null;

  return (
    <>
      {!b2b && !shortMode && (
        <div
          className="room-icon cur-poi"
          style={{ flex: `0 0 auto` }}
          onClick={onCancellationClick}
        >
          {new Date(limitDate) > new Date(2000, 0, 1) && new Date(limitDate) < new Date() && (
            <div className="room-date-long room-date-danger">
              {t('hotel.full_cancellation_fee')}
            </div>
          )}
          {new Date(limitDate) > new Date(2000, 0, 1) && new Date(limitDate) > new Date() && (
            <div dir="ltr" className="room-date-long">
              {t('hotel.free_cancel_before')} {dateFormat(limitDate, 'dd MMM yyyy', i18n.language)}
            </div>
          )}
          {new Date(limitDate) < new Date(2000, 0, 1) && (
            <div dir="ltr" className="room-date room-date-no">
              <FontAwesomeIcon icon={faExclamationTriangle} />
            </div>
          )}
        </div>
      )}
      {!hideRemarks && (
        <div className="room-icon active-meal" style={{ flex: '0 0 34px' }}>
          {hasRemarks && (
            <span
              onClick={onRemarksClick}
              className="active-meal-i active-i cur-poi"
              style={{ width: 30, borderColor: 'var(--color-border)' }}
            >
              <FontAwesomeIcon
                icon={faCircleInfo as any}
                style={{ marginTop: 2, marginLeft: 0 }}
                className="text-light"
                size="sm"
              />
            </span>
          )}
        </div>
      )}
      <div className="room-icon active-meal" style={{ flex: `0 0 34px` }}>
        {validBoardCode && validBoardCode !== 'RO' && (
          <span className="active-meal-i active-i">
            {['BB', 'HB', 'FB', 'AI', 'M'].includes(validBoardCode) && validBoardCode}
            {validBoardCode === 'BB' && <FontAwesomeIcon icon={faCoffee} />}
            {!['BB', 'RO'].includes(validBoardCode) && <FontAwesomeIcon icon={faUtensils} />}
          </span>
        )}
        {(validBoardCode === 'RO' || !boardCode || boardCode === 'null') && (
          <span className="active-meal-i active-i active-meal-i-ro">
            RO
            <FontAwesomeIcon icon={faCoffee} />
          </span>
        )}
      </div>

      {(b2b || shortMode) && (
        <div
          className="room-icon cur-poi"
          style={{ flex: `0 0 72px` }}
          onClick={onCancellationClick}
        >
          {new Date(limitDate) > new Date(2000, 0, 1) && new Date(limitDate) < new Date() && (
            <div className="room-date room-date-danger">NO REF</div>
          )}
          {new Date(limitDate) > new Date(2000, 0, 1) && new Date(limitDate) > new Date() && (
            <div dir="ltr" className="room-date">
              {dateFormat(limitDate, 'dd MMM', 'en')}
            </div>
          )}
          {new Date(limitDate) < new Date(2000, 0, 1) && (
            <div dir="ltr" className="room-date room-date-no">
              <FontAwesomeIcon icon={faExclamationTriangle} />
            </div>
          )}
        </div>
      )}

      <div className="room-icon active-ada" style={{ flex: `0 0 34px` }}>
        {ada && (
          <div className="active-ada-i active-i">
            <FontAwesomeIcon icon={faAccessibleIcon} />
          </div>
        )}
      </div>
    </>
  );
};

export default withErrorBoundary(RoomIcons, 'RoomIcons');
